import React from "react";
import Iframe from 'react-iframe'
import regex from 'filename-regex';

class PdfViewer extends React.Component {
  componentDidMount(){
    document.addEventListener("keydown", this.onKeyDown, false);
  }

  componentWillUnmount(){
    document.removeEventListener("keydown", this.onKeyDown, false);
  }

  onKeyDown = (event) => {
    if(event.keyCode === 27) {
      //Esc key press
      this.closeViewer();
    }
  }

  closeViewer = () => {
    if(this.props.onClose) this.props.onClose();
  }

  render() {
    const {url} = this.props;

    if(!url) return null;

    console.log("PDFViewer", url);

    return (
        <div className='pdf-container'>
          <div className='pdf-header'>
            <nav className="level">
              <div className="level-left">
                <p className="level-item">
                  {url.match(regex())[0]}
                </p>
              </div>
              <div className="level-right">
                <p className="level-item">
                  <a className="button is-small" onClick={this.closeViewer}>
                    Close
                  </a>
                </p>
              </div>
            </nav>
          </div>

          <Iframe url={url}
                  className="pdf-viewer"
                  display="initial"
                  position="fixed"
                  width = '800'
                  allowFullScreen/>
          </div>
      );
  }
}

export { PdfViewer };
